import { navigate } from "gatsby";

const NAV_KEY = "chatmutuo:nav";
const TTL_MS = 30 * 60 * 1000;

export function saveScrollAndNavigateToChat(
  url,
  { treatAsReturnTarget = false, widgetWasOpen = false } = {}
) {
  if (typeof window === "undefined") return;
  try {
    sessionStorage.setItem(
      NAV_KEY,
      JSON.stringify({
        fromPath: window.location.pathname,
        scrollY: window.scrollY || window.pageYOffset || 0,
        treatAsReturnTarget,
        widgetWasOpen,
        ts: Date.now(),
      })
    );
  } catch (_) {}
  navigate(url);
}

export function saveScrollForWidgetMutuoNav(url, navigateOpts = {}) {
  if (typeof window === "undefined") return;
  try {
    sessionStorage.setItem(
      NAV_KEY,
      JSON.stringify({
        fromPath: window.location.pathname,
        scrollY: window.scrollY || window.pageYOffset || 0,
        treatAsReturnTarget: true,
        widgetWasOpen: true,
        ts: Date.now(),
      })
    );
  } catch (_) {}
  navigate(url, {
    ...navigateOpts,
    state: { ...(navigateOpts.state || {}), from: window.location.pathname, full: true },
  });
}

export function readChatNavPayload() {
  if (typeof window === "undefined") return null;
  try {
    const raw = sessionStorage.getItem(NAV_KEY);
    if (!raw) return null;
    const p = JSON.parse(raw);
    if (!p.ts || Date.now() - p.ts > TTL_MS) {
      sessionStorage.removeItem(NAV_KEY);
      return null;
    }
    return p;
  } catch (_) {
    return null;
  }
}

export function clearChatNavPayload() {
  if (typeof window === "undefined") return;
  try {
    sessionStorage.removeItem(NAV_KEY);
  } catch (_) {}
}

export function saveChatNavForMobileReturn(fromPath) {
  if (typeof window === "undefined") return;
  try {
    sessionStorage.setItem(
      NAV_KEY,
      JSON.stringify({
        fromPath,
        scrollY: 0,
        treatAsReturnTarget: false,
        widgetWasOpen: true,
        ts: Date.now(),
      })
    );
  } catch (_) {}
}

export function handleServiceBarChatClick(
  chatSlug,
  currentPathname,
  { treatAsReturnTarget = false } = {}
) {
  const target = `/${chatSlug}`;
  const isOnChat =
    currentPathname === target || currentPathname === `${target}/`;

  if (!isOnChat) {
    saveScrollAndNavigateToChat(target, { treatAsReturnTarget });
    return;
  }

  const payload = readChatNavPayload();
  if (payload?.treatAsReturnTarget) {
    navigate(-1);
  } else {
    clearChatNavPayload();
    navigate("/");
  }
}
